import { Form } from '@/components/formik-rsuite';
import PageLoader from '@/components/shared/PageLoader';
import { LEVEL_TYPE } from '@/constants';
import useLeaseBasic from '@/hooks/preload/useLeaseBasic';
import useLoading from '@/hooks/useLoading';
import { LeaseBasic } from '@/providers/ReadyProvider';
import { fetchAddEditLease } from '@/services/site/lease';
import { getParamsWithNilToString } from '@/services/utils';
import { push } from '@/utils/history';
import { useRequest } from 'ahooks';
import { FormikProvider, useFormik } from 'formik';
import React, { useState } from 'react';
import { Alert } from 'rsuite';
import { SiteContext } from '..';
import { defaultLeaseInfo, leaseSchema } from './constants';
import GoodsForm from './GoodsForm';
import LeaseInfoForm from './LeaseInfoForm';

interface LeaseContextValue {
  leaseBasic: LeaseBasic;
}

export const LeaseContext = React.createContext<LeaseContextValue>(null);

const Lease = () => {
  const { member } = React.useContext(SiteContext);
  const { data: leaseBasicData, loading: leaseBasicLoading } = useLeaseBasic();

  const { run: addEditLease, loading: addEditLeaseLoading } = useRequest(fetchAddEditLease, {
    manual: true,
  });

  const [defaultInfo, setDefaultInfo] = useState(defaultLeaseInfo);

  const formik = useFormik({
    initialValues: defaultInfo,
    validationSchema: leaseSchema,
    enableReinitialize: true, // initialValues默认值受控
    onSubmit(values, actions) {
      const data = Object.assign({}, getParamsWithNilToString(values), {
        lease_items: JSON.stringify(values.lease_items),
        [member?.level === LEVEL_TYPE.NOT ? 'not_member_id' : 'member_id']: member?.id,
      });
      addEditLease(data)
        .then((res) => {
          if (res?.id) {
            const { id } = res;
            Alert.success(res?.msg ?? '保存成功');
            push(`/site-service/record/info/lease/${id}`);
          }
        })
        .catch((e) => {
          actions.setErrors(e.formError);
        });
    },
  });

  const loading = useLoading(leaseBasicLoading) || addEditLeaseLoading;

  return (
    <LeaseContext.Provider
      value={{
        leaseBasic: leaseBasicData,
      }}
    >
      {loading && <PageLoader />}
      <FormikProvider value={formik}>
        <Form guard>
          <LeaseInfoForm leaseBasic={leaseBasicData} />
          <GoodsForm formik={formik} />
        </Form>
      </FormikProvider>
    </LeaseContext.Provider>
  );
};

export default Lease;
